import {RECEIVE_BACKEND_STATE} from '../constants';
import { AnyAction } from "redux";

export type BackendState = {
    dbEnvironment: string;
    wsEnvironment: string;
}

/**
 *
 * @param state
 * @param action
 */
export default function backendStateReducer( state: BackendState = { dbEnvironment: 'n/a', wsEnvironment: 'n/a' },
                                             action: AnyAction ): BackendState {

    switch ( action.type ) {
        case RECEIVE_BACKEND_STATE:
            state = {
                dbEnvironment: action.dbEnvironment,
                wsEnvironment: action.wsEnvironment
            };
            break;
    }

    return state;
}
